import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";
import { isUserSiteAdmin, checkUserAffiliationForPermissions } from "../../shared/utilities";
import { useEffect, useState } from "react";

export const MobileNavBarTabs = ({ handleClick }) => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const isAdmin = isUserSiteAdmin(user);

  return (
    <div className="mobile-nav-bar__tabs">
      {isAuthenticated && (
        <>
          <MobileNavBarTab
            path="/profile"
            label="Profile"
            handleClick={handleClick}
          />

          <MobileNavBarTab path="/content/all" label="Content" />
          <MobileNavBarTab path="/contacts/all" label="Contacts" />
          <MobileNavBarTab path="/events/all" label="Events" />

          { isAdmin &&
            <MobileNavBarTab
              path="/admin"
              label="Admin"
              handleClick={handleClick}
            />
          }
          <MobileNavBarTab
            path="/"
            label="Home"
          handleClick={handleClick}
      />
        </>
      )}
    </div>
  );
};
